import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../../config/firebase';
import { UserContext } from '../../../api/userContext';
import { ROUTES } from '../../../config/routes';

const styles = {
  passwordToggle: {
    position: 'absolute',
    right: '10px', // Adjust the position to the right inside the input field
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
  },
  passwordToggleIcon: {
    fontSize: '18px',
    lineHeight: '1',
    color: '#333',
    transition: 'color 0.3s ease-in-out',
  },
  passwordToggleIconHover: {
    color: '#007bff', // Change color on hover
  },
};

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLogin, setIsLogin] = useState(true); // State to toggle between login and signup
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const { user, setUser, setIsAdmin } = useContext(UserContext);
  const history = useHistory();


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      let userCredential;
      
      if (isLogin) {
        userCredential = await signInWithEmailAndPassword(auth, email, password);
      } else {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);
      }

      const user = userCredential.user;

      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        setUser(user);
        setIsAdmin(idTokenResult.claims.admin || false);

        history.push('/');

      }
    } catch (error) {
      let errorMessage;
      switch (error.code) {
        case 'auth/user-not-found':
          errorMessage = 'Erreur, veuillez vérifier votre email/mot de passe.';
          break;
        case 'auth/wrong-password':
          errorMessage = 'Erreur, veuillez vérifier votre email/mot de passe.';
          break;
        case 'auth/email-already-in-use':
          errorMessage = 'Cet email est déjà utilisé. Veuillez utiliser un autre email.';
          break;
        case 'auth/weak-password':
          errorMessage = 'Le mot de passe est trop faible. Veuillez choisir un mot de passe plus fort (majuscules, minuscules, caractères spéciaux).';
          break;
        default:
          errorMessage = 'Une erreur est survenue. Veuillez réessayer.';
      }
      setError(errorMessage);
    }
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null);
      setIsLogin(true); // Set to show the login form
      setTimeout(() => {
        history.push('/');
      }, 2000); // Wait for 2 seconds before redirecting
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="blog-area gray-300">
      <div className="container position-relative pt-110">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-head">
              <h3>{user ? 'Mon compte' : (isLogin ? 'Connexion' : 'Créer un compte')}</h3>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7 col-sm-10">
            {user ? (
              <div className="contact-form-wrapper text-center">
                <h4 className="contact-form-title">Vous êtes déjà connecté</h4>
                <div className="submit-btn mt-20">
                  <button onClick={handleLogout} type="submit" className="btn btn-primary">
                    Déconnexion
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-center mb-4">
                  <div className="btn-group" role="group" aria-label="Basic example">
                    <button
                      type="button"
                      className={`btn ${isLogin ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setIsLogin(true)}
                    >
                      Connexion
                    </button>
                    <button
                      type="button"
                      className={`btn ${!isLogin ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setIsLogin(false)}
                    >
                      Créer un compte
                    </button>
                  </div>
                </div>
                <form action="#" onSubmit={handleSubmit} id="contact-form">
                  <div className="contact-form-wrapper">
                    <div className="primary-input-group">
                      <input
                        type="email"
                        id="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="primary-input-group" style={{ position: 'relative' }}>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        placeholder="Mot de passe"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        className="password-toggle"
                        style={styles.passwordToggle}
                        onMouseEnter={(e) => e.currentTarget.firstChild.style.color = styles.passwordToggleIconHover.color}
                        onMouseLeave={(e) => e.currentTarget.firstChild.style.color = styles.passwordToggleIcon.color}
                      >
                        <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} style={styles.passwordToggleIcon}></i>
                      </span>
                    </div>
                    {isLogin && (
                      <div className="forgot-password-link">
                        <a href={ROUTES.FORGOTTEN_PASSWORD.path}>Mot de passe oublié ?</a>
                      </div>
                    )}
                    {error && <p className="error">{error}</p>}
                    <div className="submit-btn">
                      <button type="submit" className="btn primary-submit">
                        {isLogin ? 'Connexion' : 'Créer un compte'}
                      </button>
                    </div>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;